export default {
    closeMargin: '18px 14px',
    closeSize: '16px',
    width: '365px',
    padding: '16px'
};
